import React, { useState } from 'react'
import VideoModal from './VideoModal';

const RiskInvolved = (props) => {
  const videoSrc = "https://www.youtube.com/embed/t7XjsCmIhSk?autoplay=1&mute=0&rel=0&controls=1&frameborder=0&modestbranding=0&showinfo=0";
  const videoQue = "Risks of Investing in Bonds";
  const videoAns = "Thinking about investing in bonds but not sure about the risks involved? In this video, we’ll break down the risks involved in Bond Investing and how they can be mitigated. By understanding these, you can make an informed investment decision.";
  const [showVideo, setShowVideo] = useState(false);

  const handlelearnCLick = () => {
    toggleVideoModal();
  }

  const toggleVideoModal = () => {
    setShowVideo(!showVideo);
  }

  return (
    <div className='risks-main-container'>
      <p className='title'>What are the risks involved?</p>

      <p onClick={() => handlelearnCLick()} className="learnmore">Watch the video to understand about risks <span class="mdi mdi-play-circle"></span></p>

      <div className="table-div">
        <div class="row1 d-flex">
          <div class="text-center column1 round1 width-20">Types of Risks</div>
          <div class="text-center column1 width-40">What do they mean?</div>
          <div class="text-center column1 round2 width-40">How have we mitigated them?</div>
        </div>
        <div class="row2 d-flex">
          <div class="text-center column2 width-20 round1 mob-font">Credit Risk</div>
          <div class="text-center column2 width-40">
            <p className='point'>Credit Risk refers to the risk that the issuer may not be able to honour the principal and coupon payments.</p>
          </div>

          {(props?.bondDetails?.product === "naviptc0" || props?.bondDetails?.product === "naviptc1") ?
            <div class="text-center column2 width-40 round2">
              <p className='point'>
                This PTC is Rated {props?.bondDetails?.rating}. The PTC has Credit Enhancement (financial support in case of delay or default)
                in the form of over-collateralisation and excess interest spread of 18.0% and 35.4% of initial
                Principal Outstanding. Additionally, a Fixed Deposit of {props?.bondDetails?.exitLoadInPerc}% of the initial principal will be kept as
                credit enhancement.
              </p>
            </div>
            :
            (props?.bondDetails?.product === "tc0" || props?.bondDetails?.product === "tc1" || props?.bondDetails?.product === "tc2") ?
            <div class="text-center column2 width-40 round2">
            <p className='point'>
            This bond is Rated {props?.bondDetails?.rating}. The Bond is secured by way of a first ranking, exclusive, and continuing charge on identified MSME Gold & Business loan receivables in the ratio 60:40 respectively for 1.1x the outstanding amount of the Bond.
            </p>
          </div>
          :
            (props?.bondDetails?.product === "keertana3") ?
              <div class="text-center column2 width-40 round2">
                <p className='point'>
                  This bond is rated BBB with a Stable Outlook by ICRA. The Bond is also secured by way of a charge
                  on hypothecated assets for 1.1x the outstanding amount of the Bond. The hypothecated assets would
                  only be Secured Loan Products with 65% constituting Gold Loans and the rest 35% being a mix of
                  Housing Loans (HL) and Loan against Property (LAP).
                </p>
              </div>
              :
              <div class="text-center column2 width-40 round2">
              <p className='point'>
                This bond is rated {props?.bondDetails?.rating} Outlook. The Bond is also secured by way of a
                charge on loan receivables for {props?.bondDetails?.securityCover} the outstanding amount
                of the Bond.
              </p>
              </div>
          }
        </div>
        <div class="row3 d-flex">
          <div class="text-center column2 width-20 bg-blue round1 mob-font">Liquidity Risk</div>
          {(props?.bondDetails?.product === "naviptc0" || props?.bondDetails?.product === "naviptc1") ?
            <>
              <div class="text-center column2 width-40 bg-blue">
                <p className='point'>
                  PTCs may not have an active secondary market, making it
                  challenging for investors to sell their holding before the
                  maturity period.
                </p>
              </div>
              <div class="text-center column2 width-40 bg-blue round2">
                <p className='point'>
                  We offer 'Anytime liquidity' functionality anytime on our
                  platform which ensures investors can liquidate their
                  investments before maturity at a discount of {props?.bondDetails?.exitLoadInPerc}% on the
                  value of the PTC.
                </p>
              </div>
            </>
            :
            <>
              <div class="text-center column2 width-40 bg-blue">
                <p className='point'>
                  Bonds may not have an active secondary market, making it
                  challenging for investors to sell their holding before the
                  maturity period.
                </p>
              </div>
              <div class="text-center column2 width-40 bg-blue round2">
                <p className='point'>
                  We offer 'Anytime liquidity' functionality anytime on our
                  platform which ensures investors can liquidate their
                  investments before maturity at a discount of {props?.bondDetails?.exitLoadInPerc}% on the
                  value of the Bond.
                </p>
              </div>
            </>
          }
        </div>
      </div>

      <VideoModal showVideo={showVideo} toggleVideoModal={toggleVideoModal} src={videoSrc} question={videoQue} answer={videoAns} />
    </div>
  )
}

export default RiskInvolved